import styled from "styled-components";

export const JetonPageStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`;
export const BoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24px;
  border-radius: 18px;
  background-color: #f6f7f9;
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
`;
export const JetonBtn = styled.div`
  border-radius: 12px;
  box-shadow: 0 3px 10px 0 rgba(255, 191, 29, 0.4);
  background-color: #ffbf1d;
  margin: 10px 0;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 999;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
